import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Link,
    Grid,
    GridItem
} from '@chakra-ui/react';
import styled from '@emotion/styled';

const LinkBox = styled(GridItem)`
    margin-bottom: 1rem;
     > a.active {
        color: #F3CB2A;
        text-decoration: none;
    }
`

export default function FooterSecondary() {
    return (
            <Box bg="blue.500" p="12">
                <Grid templateColumns={{base: "repeat(1fr)", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(5, 1fr)", xl: "repeat(6, 1fr)"}} gap="1em">
                    <LinkBox>
                        <Link as={GatsbyLink} to="/discover" state={{eatListingTag: 'restaurant'}} variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                            Discover
                        </Link>
                        <Link as={GatsbyLink} to="/discover/maps-travel-info" variant="footer-link" partiallyActive={true}>
                            Maps &amp; Travel Info
                        </Link>
                        <Link as={GatsbyLink} to="/discover/winter" variant="footer-link" partiallyActive={true}>
                            Winter
                        </Link>
                        <Link as={GatsbyLink} to="/discover/spring" variant="footer-link" partiallyActive={true}>
                            Spring
                        </Link>
                        <Link as={GatsbyLink} to="/discover/summer" variant="footer-link" partiallyActive={true}>
                            Summer
                        </Link>
                        <Link as={GatsbyLink} to="/discover/fall" variant="footer-link">
                            Fall
                        </Link>
                        {/* <Link as={GatsbyLink} to="/events" variant="footer-link">
                            Events
                        </Link> */}
                    </LinkBox>
                    <LinkBox>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                            Stay
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'resorts/hotel'}}>
                            Resorts &amp; Hotels
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'bed & breakfast'}}>
                            B &amp; B
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'short term rentals'}}>
                            Short Term Rentals
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'rvs & camping'}}>
                            RVs &amp; Camping
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'lodge'}}>
                            Lodge
                        </Link>
                        <Link as={GatsbyLink} to="/stay" variant="footer-link" state={{eatListingTag: 'pool/hot tub'}}>
                            Pool/Hot Tub
                        </Link>
                    </LinkBox>
                    <LinkBox>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                            Play
                        </Link>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" state={{eatListingTag: 'outdoors & sports'}}>
                            Outdoors &amp; Sports
                        </Link>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" state={{eatListingTag: 'arts & culture'}}>
                            Arts &amp; Culture
                        </Link>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" state={{eatListingTag: 'family fun'}}>
                            Family Fun
                        </Link>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" state={{eatListingTag: 'shopping'}}>
                            Shopping
                        </Link>
                        <Link as={GatsbyLink} to="/news" variant="footer-link">
                            Events
                        </Link>
                        <Link as={GatsbyLink} to="/play" variant="footer-link" state={{eatListingTag: 'fitness'}}>
                            Fitness
                        </Link>
                    </LinkBox>
                    <LinkBox>
                    <Link as={GatsbyLink} to="/eat" variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                            Eat
                        </Link>
                    <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'breakfast'}} variant="footer-link">
                            Breakfast
                        </Link>
                        <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'lunch'}} variant="footer-link">
                            Lunch
                        </Link>
                        <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'dinner'}} variant="footer-link">
                            Dinner
                        </Link>
                        <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'beer/wine'}} variant="footer-link">
                            Beer/Wine
                        </Link>
                        <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'libations'}} variant="footer-link">
                            Libations
                        </Link>
                        <Link as={GatsbyLink} to="/eat" state={{eatListingTag: 'groceries'}} variant="footer-link">
                            Groceries
                        </Link>
                    </LinkBox>
                    <LinkBox>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                            Live
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" state={{eatListingTag: 'auto'}}>
                            Auto
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" state={{eatListingTag: 'city of library'}}>
                            Public Services
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" state={{eatListingTag: 'retail'}}>
                            Retail
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" state={{eatListingTag: 'residential'}}>
                            Residential
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link" state={{eatListingTag: 'non-profit/civic'}}>
                            Non-profit
                        </Link>
                        <Link as={GatsbyLink} to="/live" variant="footer-link">
                           Local Services
                        </Link>
                    </LinkBox>
                    <LinkBox>
                        {/* <Box mb="4">
                            <Link as={GatsbyLink} to="/chamber-of-commerce" state={{eatListingTag: 'restaurant'}} variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                                Chamber
                            </Link>
                            <Link as={GatsbyLink} to="/chamber-of-commerce/events" variant="footer-link">
                                Events
                            </Link>
                            <Link as={GatsbyLink} to="/chamber-of-commerce/job-employee-resources" variant="footer-link">
                                Job Resources
                            </Link>
                            <Link as={GatsbyLink} to="/chamber-of-commerce/join" variant="footer-link">
                                Join the Chamber
                            </Link>
                            <Link as={GatsbyLink} to="/chamber-of-commerce/current-members" variant="footer-link">
                                Current Members
                            </Link>
                        </Box> */}
                        <Box mb="4">
                            <Link as={GatsbyLink} to="/trec" variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                                TREC
                            </Link>
                            <Link as={GatsbyLink} to="/trec/trec-staff-board" variant="footer-link">
                                Staff &amp; Board
                            </Link>
                            <Link as={GatsbyLink} to="/trec/business-resources" variant="footer-link">
                                Business Resources
                            </Link>
                            <Link as={GatsbyLink} to="/trec/business-involvement" variant="footer-link">
                                Business Involvement
                            </Link>
                        </Box>
                        {/*  <Box>
                            <Link as={GatsbyLink} to="/teton-geo-center" state={{eatListingTag: 'restaurant'}} variant="footer-link" textTransform="uppercase" fontWeight="900" fontSize="1.5rem">
                                GEO CENTER
                            </Link>
                            <Link as={GatsbyLink} to="/teton-geo-center/geo-board" variant="footer-link">
                                Geo Board
                            </Link>
                            <Link as={GatsbyLink} to="/teton-geo-center/idea-gallery-artwork" variant="footer-link">
                                Idea Gallery Artwork
                            </Link>
                            <Link as={GatsbyLink} to="/teton-geo-center/donate" variant="footer-link">
                                Donate
                            </Link>
                            <Link as={GatsbyLink} to="/teton-geo-center/volunteer" variant="footer-link">
                                Volunteer
                            </Link>
                        </Box> */}
                     </LinkBox>
                   
                </Grid>
                </Box>
    )
}